module.exports = __webpack_public_path__ + "menu_2.be02c761.png";